import { graphql, getAuctionUserApi } from './api'
import { updateCurrentBidMutation, purchaseFixedItemMutation, makeDonationMutation } from './graphql/Mutations'

export const updateLiveBid = async (bidFields) => {
  console.log('updateLiveBid!')

  const variables = {userId: "{UserIdFromToken}", ...bidFields}
  try {
    const response = await graphql({query: updateCurrentBidMutation, variables })
    if (!response?.data?.updateCurrentBid?.BidCount) {
      console.log("Bid failed: ", response)
      return {error: {response}}
    }
    else {
      return response.data.updateCurrentBid
    }
  }
  catch (e) {
    console.log("error in updateLiveBid:", e)
    if (e.toString().startsWith("Error: No current user")) {
       // In practice we will redirect the user to the login page here
       return {error: {message: "You need to be logged in to use this service."}}
    }
    else if (e.errors[0]?.message?.startsWith("The conditional request failed")) {
      // reloading all data to see what actual current price is
      // in practice we will know if the user was outbid or lost to an equal bid getting in ahead of them, but for now this is ok
      return {error: {message: "Oops you've been outbid or another bid snuck in just ahead of you. Would you like to bid again?"}}
    }
    else {
      return {error: {e}}
    }
  }
  // finally {
  //   // always refresh list on any attempted bid
  //   setAuctionDetail(await getLiveAuctionData(auctionId))
  // }
}

export const purchaseFixedItem = async (purchaseFields) => {
  console.log('purchaseFixedItem!')

  console.log('purchaseFields', purchaseFields)

  try {
    const response = await graphql({query: purchaseFixedItemMutation, variables: purchaseFields })

    console.log('purchase response', response)

    if (!response?.data?.purchaseFixedItem?.TotalItemsPurchased) {
      console.log("Purchase failed: ", response)
      return {error: {response}}
    }
    else {
      return response.data.purchaseFixedItem
    }
  }
  catch (e) {
    console.log("error in purchaseFixedItem:", e)
    if (e.toString().startsWith("Error: No current user")) {
       // In practice we will redirect the user to the login page here
       return {error: {message: "You need to be logged in to use this service."}}
    }
    else if (e.errors[0]?.message?.startsWith("The conditional request failed")) {
      // reloading all data to see what actual current price is
      // in practice we will know if the user was outbid or lost to an equal bid getting in ahead of them, but for now this is ok
      return {error: {message: "Oops you've been outbid or another bid snuck in just ahead of you. Would you like to bid again?"}}
    }
    else {
      return {error: {e}}
    }
  }
  // finally {
  //   // always refresh list on any attempted bid
  //   setAuctionDetail(await getLiveAuctionData(auctionId))
  // }
}

export const makeDonation = async (amount, auctionId) => {
  console.log('makeDonation!')

  const variables = {amount, auctionId}

  console.log('variables', variables)

  try {
    const response = await graphql({query: makeDonationMutation, variables })

    console.log('make donation response', response)

    if (!response?.data?.makeDonation?.UserDonationTotal) {
      console.log("Purchase failed: ", response)
      return {error: {response}}
    }
    else {
      // refresh auction user
      await getAuctionUserApi()
      return response.data.makeDonation
    }
  }
  catch (e) {
    console.log("error in makeDonation:", e)
    if (e.toString().startsWith("Error: No current user")) {
       return {error: {message: "You need to be logged in to use this service."}}
    }
    else if (e.errors[0]?.message?.startsWith("The conditional request failed")) {
       return {error: {message: "Registration ID does not match User"}}
    }
    else {
      return {error: {e}}
    }
  }
}